import React from 'react'
import { FormattedMessage } from 'react-intl'

export const STATUS_MESSAGES = {
    BATTLES_AVAILABLE: (
        <FormattedMessage
            id='battle_wizard_status.battles_available'
            defaultMessage='Вылазки доступны'
        />
    ),
    START_UNKNOWN: (
        <FormattedMessage
            id='battle_wizard_status.begin_unknown'
            defaultMessage='Начало уточнится позже'
        />
    ),
    STARTS_NOT_SOON: (
        <FormattedMessage
            id='battle_wizard_status.begin_not_soon'
            defaultMessage='Начало:'
        />
    ),
    STARTS_SOON: (
        <FormattedMessage
            id='battle_wizard_status.begin_soon'
            defaultMessage='До начала'
        />
    ),
}



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Status/constants.jsx